// extracted by mini-css-extract-plugin
export default {"buttons":"ButtonTable_buttons__BvDzO","table":"ButtonTable_table__LkJcR","title":"ButtonTable_title__T3rEH"};